<template>
  <div class="ov">
    <div id="pinglunshow">
      <div class="title">
        <h1>{{product.newsname}}</h1>
        <div class="article" v-html="product.newscontent"></div>
        <div class="back"><a href=javascript:history.go(-1);>&gt;&gt; 返回</a></div>
      </div>
    </div>
  </div>
</template>

<script>
import finder from '../mock/finder.json'

export default {
  name: 'pinglun',
  props: ['id'],
  data () {
    return {
      finder
    }
  },
  computed: {
    product () {
      let product = this.finder.finder_news.filter(item => item.newsid == this.id) || [{}]
      return product.pop()
    }
  }
}
</script>
